import Footer from '../layout/footer.vue';

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js